import axios from 'axios'
import setupAxios from './SetupAxios'

/**
 * Firma bağlamlı servisler için axios instance'ı.
 * Her isteğe oturumdaki corporateId'yi `?corporateId=` parametresi olarak ekler.
 * Backend firmayı token'dan alır; bu parametre token ile uyuşmazsa istek 403 ile reddedilir.
 */
export const corporateApi = axios.create()

export function setupCorporateApi(store: any) {
  setupAxios(corporateApi, store)

  corporateApi.interceptors.request.use(
    (config: any) => {
      const {
        auth: {corporateId},
      } = store.getState()

      if (corporateId) {
        config.params = {corporateId, ...config.params}
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}
